import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MenuUiState {
  activeIndex: number | null;  // Save the active index, default is 0 or null
  openMenuIndex: number | null; // Save the open menu index 
}

const initialState: MenuUiState = {
  activeIndex: 0,
  openMenuIndex: 0, 
};

const menuUiSlice = createSlice({
  name: 'menuUi',
  initialState,
  reducers: {
    setActiveIndex: (state, action: PayloadAction<number>) => {
      state.activeIndex = action.payload;
    },
    setOpenMenuIndex: (state, action: PayloadAction<number | null>) => {
      state.openMenuIndex = action.payload;
    }, 
    resetMenuUi: (state) => {
      state.activeIndex = 0;
      state.openMenuIndex = 0; 
    },
  },
});

export const { setActiveIndex, setOpenMenuIndex, resetMenuUi } = menuUiSlice.actions;
export default menuUiSlice.reducer;
